import { ApiErrorTypes } from 'constants/apiErrors'
import { ApplicationsContent } from 'pages/applications/list/components/ApplicationsContent'
import { ApplicationsSearch } from 'pages/applications/list/components/ApplicationsSearch'
import { ApplicationFiltersTags } from 'pages/applications/list/components/filterTags/ApplicationFiltersTags'
import { useApplicationsQuery } from 'pages/applications/list/useApplicationsQuery'
import { ErrorPage } from 'ui-base/errorPage/ErrorPage'
import { CatalogueIntroSection } from 'ui-shared/catalogueIntroSection/CatalogueIntroSection'
import { CatalogueSearch } from 'ui-shared/catalogueIntroSection/components/CatalogueSearch'

import * as S from 'pages/applications/list/ApplicationsListPage.styled'

export const ApplicationsListPage = () => {
  const { isLoading, appsQueriesMap, isError, resultsNumber, hasFilters, isSearchApplied } = useApplicationsQuery()

  // error page
  if (isError && !isLoading) {
    return <ErrorPage errorType={ApiErrorTypes.SERVER_ERROR} style={{ margin: '100px 0' }} />
  }

  return (
    <S.Wrapper data-testid="application-list-wrapper" direction="column">
      {hasFilters ? (
        <>
          <CatalogueSearch>
            <ApplicationsSearch />
          </CatalogueSearch>
          <ApplicationFiltersTags
            isLoading={isLoading}
            resultsNumber={resultsNumber}
            isSearchApplied={isSearchApplied}
          />
        </>
      ) : (
        <CatalogueIntroSection>
          <ApplicationsSearch />
        </CatalogueIntroSection>
      )}
      <ApplicationsContent
        isLoading={isLoading}
        appsQueriesMap={appsQueriesMap}
        resultsNumber={resultsNumber}
        hasFilters={hasFilters}
      />
    </S.Wrapper>
  )
}
